module.exports = __webpack_public_path__ + "img/crosslink-search-results.4166d20a.png";